import styles from "./CheckOut.module.css"
import {useEffect, useRef } from "react";
import logo from "../../assets/images/logo.svg"
import Payment from "./Payment";
import LoadingScreen from "../../components/LoadingScreen/LoadingScreen";

import { useDispatch, useSelector } from "react-redux";
import { fetchOrder } from "../../store/slices/orderSlice";
import { useNavigate } from "react-router-dom";
import Button from "../../components/Button";
import { getLensDisplayName } from "../../utils/lens";
import { buildOrderAnalyticsProps, capture } from "../../analytics";

const FinishCheckout =()=>{

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const {order, status} = useSelector(state=> state.order)
  const {profile} = useSelector(state=> state.profile)
  const checkoutViewedRef = useRef(null);
  
  useEffect(()=>{
    const fetchOrderData = async () => {
      try {
        await dispatch(fetchOrder()).unwrap();
      } catch (error) {
        console.error("Failed to fetch order:", error);
      }
    };

    fetchOrderData();
  },[dispatch])

   useEffect(() => {
      document.title = "Distortion Grids Database - CheckOut";
      
      const ogTitle = document.querySelector('meta[property="og:title"]');
      if (ogTitle) {
        ogTitle.content = "Distortion Grids Database - CheckOut";
      }
    }, []);

  useEffect(() => {
    const currentOrder = order?.order;
    if (
      status.fetchOrderStatus !== "succeeded" ||
      !currentOrder?.id ||
      checkoutViewedRef.current === currentOrder.id
    ) {
      return;
    }

    checkoutViewedRef.current = currentOrder.id;
    capture("checkout_viewed", {
      ...buildOrderAnalyticsProps(currentOrder),
    });
  }, [status.fetchOrderStatus, order]);

  if(status.fetchOrderStatus === "loading"){
    return <LoadingScreen/>
  }

if(status.fetchOrderStatus === "succeeded"&&order.order.items){
  return (
    <div className={styles.main}>
      <div className={styles.header}>
        <div className={styles.logocont} onClick={()=>navigate("/")}>
          <img src={logo} alt="logo" />
        </div>
       {profile?.email && (
  <div className={styles.emailcont}>
    <p className={styles.email}>Email:</p>
    <a target="_blank" className={styles.email} href={`mailto:${profile.email}`}>
      {profile.email}
    </a>
  </div>
)}

      </div>
      <div className={styles.body}>
        <div className={styles.orderInfo}>
          <div className={`${styles.check} h5-light`}>
            
              {order.order.items.map((item)=>
                <div key={item.id} className={styles.checkField}>
                  <p>{getLensDisplayName(item.product.lens)}</p> 
                  <p>${item.price}</p>
                </div>
              )}
            
            <div className={styles.checkField}>
              <p>Subtotal: </p> <p>${order.order.total_price}</p>
            </div>
            {order.order.discount_amount > 0 && (
              <div className={styles.checkField}>
                <p>Discount ({order.order.user_discount_percentage}%): </p> 
                <p>-${order.order.discount_amount}</p>
              </div>
            )}
            <div className={`${styles.checkField} ${styles.total} h4-medium`}>
              <p>Total: </p> <p>${order.order.final_amount}</p>
            </div>
            <div className={styles.line} />
            <p className={styles.advice}>
              The price of all chosen assets includes VAT.<br />
            </p>
          </div>
          <div className={styles.cancelContainer}>
          <Button
              variant="outline-red"
              label="Cancel"
              onClick={() => navigate("/")}
            />
            </div>
        </div>
        <div className={styles.proceed}>
          <Payment  orderId={order.order.id} order={order.order} />
        </div>
      </div>
    </div>
  );
}

if(status.fetchOrderStatus === "failed"){
   return (
     <section className="width">
       <h2 className="h2-medium">Item not found or an error occurred.</h2>{" "}
       <p className="h4-medium">Please try again.</p>
     </section>
   );
}
}

export default FinishCheckout
